import type { DanceSeoHead } from "../danceSeoTypes.js";

// ja translation of shared/danceSeoHeads/en.ts; numbers and claims must stay in sync with the English source.
const head: DanceSeoHead = {
  director: {
    title: "AIダンス動画生成｜曲からダンス動画を作成・無料で開始",
    description:
      "どんな曲もフル尺のAIダンス動画に。Solmiがセクションごとに振付を計画し、全ショットの絵コンテを作り、ダンスとリップシンクをレンダリング。無料で開始。",
    h1: "AIダンス動画生成 — どんな曲もダンス動画に",
  },
  photo: {
    title: "写真を踊らせるAI｜写真からAIダンスを生成 | Solmi",
    description:
      "AIで写真を踊らせよう。全身写真をアップし、動きを選ぶか自分のダンスクリップをアップして、曲を追加。Solmiがダンスをビートに合わせます。無料で開始。",
    h1: "写真を踊らせる — 写真からAIダンスを生成",
  },
  inbound:
    "パフォーマーを踊らせたいなら、[AIダンス動画生成](/ai-dance-video-generator)へ。曲のセクションごとに振付を計画し、フル尺のダンス動画をレンダリングします。",
};

export default head;
